import type { SVGProps } from 'react';

/** Icones de traco fino (1,5px, pontas arredondadas), 24x24, na cor do texto (`currentColor`). */
function Icone({ children, ...p }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={20}
      height={20}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...p}
    >
      {children}
    </svg>
  );
}

export const IconeSol = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Icone>
);

export const IconeLua = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
  </Icone>
);

export const IconeMonitor = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </Icone>
);

export const IconeLista = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Icone>
);

export const IconeComparar = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M7 4v16M17 4v16M3 8h8M13 16h8" />
  </Icone>
);

export const IconeVoltar = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M15 18l-6-6 6-6" />
  </Icone>
);

export const IconeVideo = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <rect x="3" y="6" width="13" height="12" rx="2" />
    <path d="M16 10l5-3v10l-5-3" />
  </Icone>
);

export const IconeCamera = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M4 8h3l2-3h6l2 3h3v11H4z" />
    <circle cx="12" cy="13" r="3.5" />
  </Icone>
);

export const IconeBusca = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="M20 20l-4-4" />
  </Icone>
);

export const IconeTabela = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M3 5h18M3 12h18M3 19h18M8 5v14" />
  </Icone>
);

export const IconeSeta = (p: SVGProps<SVGSVGElement> & { direcao?: 'cima' | 'baixo' }) => {
  const { direcao = 'baixo', ...resto } = p;
  return (
    <Icone {...resto}>
      <path d={direcao === 'baixo' ? 'M6 9l6 6 6-6' : 'M6 15l6-6 6 6'} />
    </Icone>
  );
};

export const IconeSincronia = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M4 12a8 8 0 0 1 13.7-5.6L20 9M20 4v5h-5M20 12a8 8 0 0 1-13.7 5.6L4 15M4 20v-5h5" />
  </Icone>
);

export const IconeUsuario = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" />
  </Icone>
);

export const IconeDocumento = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h7" />
  </Icone>
);

export const IconeAvancar = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M9 18l6-6-6-6" />
  </Icone>
);

export const IconeInicio = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1z" />
  </Icone>
);

export const IconeRelogio = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </Icone>
);

export const IconeSelo = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M12 3l2.3 1.7 2.8-.1.9 2.7 2.3 1.6-.9 2.7.9 2.7-2.3 1.6-.9 2.7-2.8-.1L12 21l-2.3-1.7-2.8.1-.9-2.7-2.3-1.6.9-2.7-.9-2.7 2.3-1.6.9-2.7 2.8.1z" />
    <path d="m8.8 12.2 2.2 2.2 4.2-4.6" />
  </Icone>
);

export const IconeAlerta = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M10.3 4.2 2.9 17.5A2 2 0 0 0 4.6 20.5h14.8a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" />
    <path d="M12 9.5v4M12 17h.01" />
  </Icone>
);

export const IconeAlvo = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="4.5" />
    <circle cx="12" cy="12" r="0.8" />
  </Icone>
);

export const IconeBroto = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M12 21v-9M12 12c0-4-3-6.5-7-6.5 0 4 3 6.5 7 6.5zM12 14c0-3.5 2.5-6 6.5-6 0 3.5-2.5 6-6.5 6z" />
  </Icone>
);

export const IconeEtiqueta = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z" />
    <circle cx="7.5" cy="7.5" r="1.5" />
  </Icone>
);

export const IconeHaras = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M3 21V9.5L12 4l9 5.5V21M3 21h18M8 21v-6h8v6M8 15l8 6M16 15l-8 6" />
  </Icone>
);

export const IconeEquipe = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18.5 20a6.5 6.5 0 0 0-2.5-5.1" />
  </Icone>
);

export const IconeSair = (p: SVGProps<SVGSVGElement>) => (
  <Icone {...p}>
    <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 16l-4-4 4-4M6 12h10" />
  </Icone>
);
